import type { FunctionComponent, PropsWithChildren } from 'react'
import React from 'react'
import { Accordion as SBAccordion } from '@which/seatbelt'

export const Accordion: FunctionComponent<PropsWithChildren<unknown>> = ({ children }) => (
  <SBAccordion>{children}</SBAccordion>
)
